import { Action, handleActions } from 'redux-actions';
import { allTenantDependentDataCleared } from '../action/authenticationEvents';
import {
    DepotAssetsFetchedPayload,
    DepotUpdatedPayload,
    DepotsFetchedPayload,
    DoorStatusFetchFailedPayload,
    DoorStatusFetchStartedPayload,
    DoorStatusFetchedPayload,
    ThingsFetchedPayload,
    depotAssetsFetched,
    depotUpdated,
    depotsFetched,
    doorStatusFetchFailed,
    doorStatusFetchStarted,
    doorStatusFetched,
    thingsFetched,
} from '../action/depotsEvents';
// import {
//     bookingOverviewFetched
// } from '../action/BookingOverviewEvents';
import { Asset, Depot, DoorStatus, Thing } from '../api/types';
// import { bookingOverviewFetched } from '../action/BookingOverviewEvents';

export interface DepotsState {
    depots: Depot[];
    // Keyed by depot id, which is a string — `doorStatusListSelector` already
    // declared it that way, so the two disagreed until now.
    doorStatus: Record<string, DoorStatus>;
    /** Per depot: a door-status fetch is in flight. Drives the reload indicator. */
    doorStatusLoading: Record<string, boolean>;
    things: Thing[];
    assets: Asset[];
}

export interface AssetsState {
    name: string;
    description: string;
    groupId: string;
}

export const initialState: DepotsState = {
    depots: [],
    doorStatus: {},
    doorStatusLoading: {},
    things: [],
    assets: [],
};

/* eslint-disable max-len */
export const reducer = handleActions<DepotsState, any>(
    {
        [depotsFetched.toString()]: (state = initialState, action: Action<DepotsFetchedPayload>) => {
            if (!state) {
                return state;
            }

            return {
                ...state,
                depots: action.payload.depots,
            };
        },
        [depotAssetsFetched.toString()]: (state = initialState, action: Action<DepotAssetsFetchedPayload>) => {
            if (!state) {
                return state;
            }

            return {
                ...state,
                assets: action.payload.assets,
            };
        },
        [doorStatusFetchStarted.toString()]: (state = initialState, action: Action<DoorStatusFetchStartedPayload>) => {
            if (!state) {
                return state;
            }

            return {
                ...state,
                doorStatusLoading: {
                    ...state.doorStatusLoading,
                    [action.payload.depotId]: true,
                },
            };
        },
        [doorStatusFetched.toString()]: (state = initialState, action: Action<DoorStatusFetchedPayload>) => {
            if (!state) {
                return state;
            }

            return {
                ...state,
                doorStatus: {
                    ...state.doorStatus,
                    [action.payload.depotId]: action.payload.doorStatus,
                },
                doorStatusLoading: {
                    ...state.doorStatusLoading,
                    [action.payload.depotId]: false,
                },
            };
        },
        [doorStatusFetchFailed.toString()]: (state = initialState, action: Action<DoorStatusFetchFailedPayload>) => {
            if (!state) {
                return state;
            }

            return {
                ...state,
                doorStatusLoading: {
                    ...state.doorStatusLoading,
                    [action.payload.depotId]: false,
                },
            };
        },
        [depotUpdated.toString()]: (state = initialState, action: Action<DepotUpdatedPayload>) => {
            if (!state) {
                return state;
            }

            return {
                ...state,
                depots: state.depots.map(depot => {
                    if (depot.id !== action.payload.id) {
                        return depot;
                    }

                    return {
                        ...depot,
                        enabled: action.payload.enabled,
                    };
                }),
            };
        },
        [thingsFetched.toString()]: (state = initialState, action: Action<ThingsFetchedPayload>) => {
            return {
                ...state,
                things: action.payload.things,
            };
        },
        [allTenantDependentDataCleared.toString()]: (state = initialState, action: Action<{}>) => {
            return {
                ...initialState,
            };
        },
        // [ bookingOverviewFetched.toString()]: (state = initialState, action: Action<{}>) => {
        //     return {
        //         ...initialState,
        //     };
        // },
    },
    initialState,
);
